export class Accordio {

    constructor ( options ) {
        this.options = options
    }

    init () {
        this.options.action_item.click( ( e ) => {
            let item_wraper = $( e.target ).closest( 'article' )
            item_wraper.toggleClass( 'active' )
            if ( typeof this.options.action_click === 'function' ) {
                this.options.action_click()
            }
        } )
    }

}


// WEBPACK FOOTER //
// ./scripts/components/accordion.js